/*
 * The entry point for running the webpage
 */
import { createApp } from "vue";
import App from "./App.vue";
import store from "./store";
import router from "./router";
import axios from "axios";

import { createBootstrap } from 'bootstrap-vue-next';

import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue-next/dist/bootstrap-vue-next.css";
import "bootstrap-icons/font/bootstrap-icons.css";

import "./assets/MarkerStyles/leaflet.awesome-markers.css";
import "./assets/MarkerStyles/leaflet.awesome-markers.js";
import "./assets/MarkerStyles/MarkerCluster.css";
import "./assets/MarkerStyles/MarkerCluster.Default.css";

// Global axios interceptor: catch server errors so they don't surface as
// unhandled promise rejections (which show the red Vue error overlay).
axios.interceptors.response.use(
  response => response,
  error => {
    const status = error.response ? error.response.status : 0;
    if (status >= 500 || status === 0) {
      console.error(`[API ${status || 'Network Error'}]`, error.config?.url || '');
      // Push to Vuex so the UI can react (toast / banner) without crashing
      store.commit('setAPIErrorInfo', { status: status || 0, msg: status >= 500 ? 'Server Error' : 'Network Error or Server Unavailable' });
    }
    return Promise.reject(error);
  }
);

// Helper function to dynamically load scripts
const loadScript = (src) => {
  return new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = src;
    script.onload = resolve;
    script.onerror = reject;
    document.head.appendChild(script);
  });
};

// Initialize Vue 3 app
const app = createApp(App);

app.use(router);
app.use(store);
app.use(createBootstrap({ 
  components: true, 
  directives: true
}));

// Add loadScript as a global property (Vue 3 way)
app.config.globalProperties.$loadScript = loadScript;

// Load Adobe PDF SDK
loadScript("https://documentcloud.adobe.com/view-sdk/main.js");

app.mount("#app");
